import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import { Link, Navigate } from "react-router-dom";

// icons + tooltip
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

export default class Banners extends Component {
  state = {
    allBanners: [],
    message: "",
    notification: false,
    noticolor: "success",
    per_pge: 20,
    page_no: 1,
    redirect: false,
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },
  };

  componentDidMount() {
    this.getBanners(this.state.page_no, this.state.per_pge);
  }

  getBanners = (page = 1, limit = 20) => {
    if (init() === "success") {
      axios
        .get(`${Constants.getUrls.getAllBanners}?page=${page}&limit=${limit}`)
        .then((resp) => {
          console.log(resp);

          if (resp.data.status === "success") {
            const items = resp.data.data || [];
            const pag = resp.data.pagination || {};

            const currentPage = pag.page || page || 1;
            const perPage = pag.limit || limit || 10;
            const totalDocs = pag.total || items.length;
            const totalPages = pag.totalpage || Math.ceil(totalDocs / perPage) || 1;

            const hasNextPage =
              typeof pag.nextpage === "boolean" ? pag.nextpage : currentPage < totalPages;
            const hasPrevPage = typeof pag.prevpage === "boolean" ? pag.prevpage : currentPage > 1;

            const nextPage = hasNextPage && currentPage < totalPages ? currentPage + 1 : null;
            const prevPage = hasPrevPage && currentPage > 1 ? currentPage - 1 : null;

            this.setState({
              allBanners: Array.isArray(items) ? items : [],
              pagination: {
                page: currentPage,
                totalPages,
                hasNextPage,
                hasPrevPage,
                nextPage,
                prevPage,
                totalDocs,
                limit: perPage,
              },
              page_no: currentPage,
              notification: true,
              message: resp.data.message || "Fetched successfully",
              noticolor: "success",
            });

            setTimeout(() => {
              this.setState({
                notification: false,
                message: "",
              });
            }, 2000);
          } else {
            this.setState({
              notification: true,
              noticolor: "error",
              message: resp.data.message || "Failed to fetch banners",
            });
            setTimeout(() => this.setState({ notification: false, message: "" }), 2500);
          }
        })
        .catch((err) => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: err.response?.data?.message || err.message || "Error fetching banners",
          });
          setTimeout(() => {
            this.setState({
              notification: false,
              message: "",
            });
          }, 2500);
        });
    } else {
      window.location.assign("/signin");
    }
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState(
      {
        per_pge: newLimit,
      },
      () => {
        this.getBanners(1, newLimit); // reset to first page
      }
    );
  };

  handlePageChange = (newPage) => {
    this.getBanners(newPage, this.state.per_pge);
  };

  handleDelete = (id) => {
    if (!id) return;
    if (init() === "success") {
      axios
        .delete(Constants.deleteUrls.deleteBanner + id)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.setState({
              notification: true,
              message: resp.data.message || "Deleted successfully",
              noticolor: "success",
            });
            setTimeout(() => {
              this.setState(
                {
                  notification: false,
                  message: "",
                },
                () => {
                  // refresh current page
                  const { page_no, per_pge } = this.state;
                  this.getBanners(page_no, per_pge);
                }
              );
            }, 1500);
          } else {
            this.setState({
              notification: true,
              message: resp.data.message || "Delete failed",
              noticolor: "error",
            });
            setTimeout(() => this.setState({ notification: false, message: "" }), 2000);
          }
        })
        .catch((err) => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: err.response?.data?.message || err.message || "Delete failed",
          });
          setTimeout(() => {
            this.setState(
              {
                notification: false,
                message: "",
              },
              () => {
                const { page_no, per_pge } = this.state;
                this.getBanners(page_no, per_pge);
              }
            );
          }, 2500);
        });
    } else {
      window.location.assign("/signin");
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/signin" replace={true} />;
    }

    const { pagination } = this.state;

    return (
      <div>
        <DashboardLayout>
          <DashboardNavbar />
          <MDBox pt={6} pb={3}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Banners List
                </MDTypography>
              </MDBox>

              <Grid item sm={4} px={2} align="right" style={{ marginTop: 12 }}>
                <Link to="/addbanner">
                  <MDButton variant="contained" size="small" color="primary">
                    Create
                  </MDButton>
                </Link>
              </Grid>

              <MDBox>
                <DataTable
                  table={{
                    columns: [
                      { Header: "serial", accessor: "serial", width: "6%" },
                      { Header: "title", accessor: "banner_title" },
                      { Header: "redirect_url", accessor: "redirect_url" },
                      { Header: "image", accessor: "image" },
                      { Header: "action", accessor: "action" },
                    ],
                    rows: this.state.allBanners.map((banner, index) => ({
                      serial: (pagination.page - 1) * pagination.limit + (index + 1),
                      banner_title: banner.banner_title || banner.title || "-",
                      redirect_url: banner.redirect_url || "-",
                      image: (
                        <img
                          src={
                            (banner.banner_image || banner.image || "").startsWith("/uploads")
                              ? Constants.imageDomain + (banner.banner_image || banner.image || "")
                              : banner.banner_image || banner.image || ""
                          }
                          height="100px"
                          alt="Banner"
                        />
                      ),
                      action: (
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          {/* Update Icon */}
                          <Tooltip title="Update Banner" placement="top">
                            <Link
                              to={{
                                pathname: "/updateBanner/" + banner._id,
                                state: { data: banner },
                              }}
                            >
                              <IconButton size="small" color="info">
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Link>
                          </Tooltip>

                          {/* Delete Icon */}
                          <Tooltip title="Delete Banner" placement="top">
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => this.handleDelete(banner._id)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ),
                    })),
                  }}
                  entriesPerPage={{ defaultValue: this.state.per_pge }}
                  page_no={pagination.page}
                  totalPages={pagination.totalPages}
                  hasNextPage={pagination.hasNextPage}
                  hasPrevPage={pagination.hasPrevPage}
                  isnextPage={pagination.nextPage}
                  prevPage={pagination.prevPage}
                  totalDocs={pagination.totalDocs}
                  onPageChange={this.handlePageChange}
                  onEntriesPerPageChange={this.handleEntriesPerPageChange}
                />
              </MDBox>

              <MDSnackbar
                color={this.state.noticolor}
                icon="notifications"
                title="VASA | Banners"
                content={this.state.message}
                dateTime="Just now"
                open={this.state.notification}
              />
            </Card>
          </MDBox>
        </DashboardLayout>
      </div>
    );
  }
}
